import React, {useEffect} from 'react';
import PropTypes from 'prop-types';
import {
	makeStyles,
	useTheme,
	useMediaQuery,
	Drawer,
	Tabs,
	Tab,
	Typography,
	Divider
} from '@material-ui/core';

import SubNavigationSelect from "./SubNavigationSelect";
import Constants from '../utils/Constants';
import { faBorderRight } from '@fortawesome/pro-regular-svg-icons';

const styles = makeStyles(theme => ({
	drawerPaper: {
		top: theme.content.top,
		width: theme.subNavigation.width,
		// width: 230,
		backgroundColor: Constants.COLORS.PRIMARY.GREY,
		margin: "0 0 0 100px",
		marginTop: 12,

		[theme.breakpoints.down('md')]: {
			width: "100%",
			height: "auto",
			borderBottom: `1px solid ${theme.palette.grey[300]}`
		},

		[theme.breakpoints.down('sm')]: {
			top: theme.content["@media (max-width: 991px)"].top
		},

		[theme.breakpoints.down('xs')]: {
			top: theme.content["@media (max-width: 767px)"].top
		}
	},

	hasNudgeBanner: {
		top: theme.spacing(21.625),

		[theme.breakpoints.down('md')]: {
			top: theme.spacing(22)
		},

		[theme.breakpoints.down('sm')]: {
			top: theme.spacing(20.375)
		},

		[theme.breakpoints.down('xs')]: {
			top: theme.spacing(18.5)
		},

		"@media (max-width: 528px)": {
			top: theme.spacing(20.75)
		}
	},

	tabs: {
		"& button": {
			textAlign: "left",
			textTransform: "none",
			margin: "0 10px",

			[theme.breakpoints.up('lg')]: {
				"& > span": {
					alignItems: "flex-start"
				}
			}
		},
		"& button.Mui-selected": {
			backgroundColor: `${theme.palette.secondary.lightGrey} !important`,
			borderRadius: 8
		}
	},

	sectionTitle: {
		fontSize: '0.9rem',
		fontWeight: 'bold',
		textTransform: 'uppercase',
		// letterSpacing: theme.spacing(.5),
		// marginLeft: theme.spacing(0.5),
		paddingTop: "1rem",
		marginBlockEnd: "1em",
		marginInlineStart: theme.spacing(1),
		marginInlineEnd: "0px"
	},

	banner: {
		position: "relative",
		left: theme.subNavigation.width,
		width: `calc(100% - ${theme.subNavigation.width}px)`
	},

	divider: {
		margin: 10
	}
}));

function SubNavigation(props) {
	const theme = useTheme();
	const isMd = useMediaQuery(theme.breakpoints.down("md"));
	const isSm = useMediaQuery(theme.breakpoints.down("sm"));
	const isXs = useMediaQuery(theme.breakpoints.down("xs"));

	let classes = styles(),
		{selectedTab, tabClicked, tabs, title, isEdit,
			setBannerClassName, hasNudgeBanner, useSelect, selectFieldId} = props;

	useEffect(() => {
		setBannerClassName(classes.banner);
	}, [classes, setBannerClassName]);

	return isEdit && (isXs || isSm) ? null : isSm && useSelect === true || isXs ? (
		<SubNavigationSelect
			items={tabs}
			value={selectedTab}
			id={selectFieldId}
			changeHandler={tabClicked}
			title="Selected Report"
			helperText="Select the report to view" />
	) : (
		<Drawer
			anchor="left"
			variant="permanent"
			classes={{
				paper: `${classes.drawerPaper} ${hasNudgeBanner ? classes.hasNudgeBanner : ""}`
			}}>
			{title && !isMd ? <Typography variant="h2" className={classes.sectionTitle}>{title}</Typography> : null}
			<Divider className={classes.divider}/>
			<Tabs
				indicatorColor="red"
				value={selectedTab}
				onChange={tabClicked}
				className={classes.tabs}
				centered={isMd}
				//scrollButtons={false}
				//variant={isSm ? "scrollable" : null}
				orientation={isMd ? "horizontal" : "vertical"}>
				{tabs.map(item => {
					return item.hasAccess ?
						<Tab
							id={item.id}
							key={item.label}
							label={item.label}
							value={item.value}
							className={classes.tab} /> : null;
				})}
			</Tabs>
		</Drawer>
	);
}

SubNavigation.defaultProps = {
	useSelect: false
};

SubNavigation.propTypes = {
	hasNudgeBanner: PropTypes.bool,
	selectedTab: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]).isRequired,
	tabClicked: PropTypes.func.isRequired,
	tabs: PropTypes.array, // {label: "", value: ""}
	title: PropTypes.string,
	setBannerClassName: PropTypes.func.isRequired,
	useSelect: PropTypes.bool,
	isEdit: PropTypes.bool,
	selectFieldId: PropTypes.string
};

export default SubNavigation;